/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserDTOFromJSON, UserDTOToJSON, } from './UserDTO';
/**
 * @export
 */
export const ProfitMarginResponseDTOMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the ProfitMarginResponseDTO interface.
 */
export function instanceOfProfitMarginResponseDTO(value) {
    return true;
}
export function ProfitMarginResponseDTOFromJSON(json) {
    return ProfitMarginResponseDTOFromJSONTyped(json, false);
}
export function ProfitMarginResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'minCost': json['minCost'] == null ? undefined : json['minCost'],
        'maxCost': json['maxCost'] == null ? undefined : json['maxCost'],
        'minProfit': json['minProfit'] == null ? undefined : json['minProfit'],
        'maxProfit': json['maxProfit'] == null ? undefined : json['maxProfit'],
        'user': json['user'] == null ? undefined : UserDTOFromJSON(json['user']),
    };
}
export function ProfitMarginResponseDTOToJSON(json) {
    return ProfitMarginResponseDTOToJSONTyped(json, false);
}
export function ProfitMarginResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'marketplace': value['marketplace'],
        'minCost': value['minCost'],
        'maxCost': value['maxCost'],
        'minProfit': value['minProfit'],
        'maxProfit': value['maxProfit'],
        'user': UserDTOToJSON(value['user']),
    };
}
